var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { isFunction } from '../_internal/data';
import { useMergedRef } from '../_internal/useMergedRef';
export var withTriggerElement = function (config) {
    if (config === void 0) { config = {}; }
    return function (WrappedComponent) {
        var _a = config.forwardRef, forwardRef = _a === void 0 ? false : _a;
        var Wrapper = React.forwardRef(function (props, ref) {
            var _a = props, triggerElement = _a.triggerElement, rawTriggerRef = _a.triggerRef, onClose = _a.onClose, rest = __rest(_a, ["triggerElement", "triggerRef", "onClose"]);
            var _b = React.useState(false), open = _b[0], setOpen = _b[1];
            var triggerRef = useMergedRef(rawTriggerRef);
            var handleClose = React.useCallback(function (e) {
                if (isFunction(onClose)) {
                    onClose(e);
                }
                setOpen(false);
            }, [onClose]);
            var fullTriggerElement = React.useMemo(function () {
                var handleToggle = function () { return setOpen(function (wasOpen) { return !wasOpen; }); };
                if (!triggerElement) {
                    return null;
                }
                if (isFunction(triggerElement)) {
                    return triggerElement(__assign({ open: open, onClick: handleToggle }, (forwardRef ? { ref: triggerRef } : {})));
                }
                return React.cloneElement(triggerElement, {
                    onClick: handleToggle,
                    ref: triggerRef,
                });
            }, [triggerElement, triggerRef, open]);
            if (!fullTriggerElement) {
                return (React.createElement(WrappedComponent, __assign({}, rest, { onClose: onClose, ref: ref, triggerRef: rawTriggerRef })));
            }
            return (React.createElement(React.Fragment, null,
                fullTriggerElement,
                React.createElement(WrappedComponent, __assign({ triggerRef: triggerRef, ref: ref }, rest, { open: open, onClose: handleClose }))));
        });
        Wrapper.displayName = WrappedComponent.displayName || WrappedComponent.name;
        return Wrapper;
    };
};
//# sourceMappingURL=withTriggerElement.js.map